import { handleActions } from "redux-actions";

const loadingReducer = handleActions(
  {
    SET_LOADING: (state, action) => ({
      loading: {
        ...state.loading,
        [action.payload.entity]: action.payload.isLoading,
      },
    }),
  },
  {},
  { namespace: "_" }
);

export default loadingReducer;
